import { type VariantProps, cva } from "class-variance-authority";
import { type JSX, splitProps } from "solid-js";
import { cn } from "~/util/utils";

const stackVariant = cva("flex flex-col space-y-2", {
	variants: {
		justify: {
			default: "justify-start",
			center: "justify-center",
			end: "justify-end",
			start: "justify-start",
			stretch: "justify-stretch",
		},
		align: {
			default: "items-center",
			start: "items-start",
			end: "items-end",
			center: "items-center",
			stretch: "items-stretch",
		},
		gap: {
			default: "gap-2",
			0: "gap-0",
			1: "gap-1",
			2: "gap-2",
			3: "gap-3",
			4: "gap-4",
			5: "gap-5",
			6: "gap-6",
			7: "gap-7",
			8: "gap-8",
			9: "gap-9",
			10: "gap-10",
		},
	},
	defaultVariants: {
		justify: "default",
		align: "default",
		gap: "default",
	},
});

interface StackProps extends JSX.HTMLAttributes<HTMLDivElement>, VariantProps<typeof stackVariant> {}

const Stack = (props: StackProps) => {
	const [local, variant, others] = splitProps(props, ["class"], ["justify", "align", "gap"]);

	return (
		<div
			class={cn(stackVariant(variant), local.class)}
			{...others}
		/>
	);
};

export type { StackProps };
export { Stack, stackVariant };
